import React from 'react'
import { Box, Flex, Loading, Message, Text } from '@workwhile/ui'
import { useVoiceAgentCallContextValue } from '../context/VoiceAgentCallContext'

export const CallStatus = () => {
  const {
    state: { callState, error },
  } = useVoiceAgentCallContextValue()

  if (callState === 'connecting') {
    return (
      <Flex alignItems="center" gap={2}>
        <Loading />
        <Text>Connecting to AI agent...</Text>
      </Flex>
    )
  }

  if (callState === 'error' && error) {
    return <Message variant="error">{error}</Message>
  }

  if (callState === 'active') {
    return (
      <Flex alignItems="center" gap={2}>
        <Box
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: '#38a169',
          }}
        />
        <Text>Call Active</Text>
      </Flex>
    )
  }

  return null
}
